import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Banner, BlockStack, Text, Button, Box, Icon } from '@shopify/polaris';
import { LockIcon } from '@shopify/polaris-icons';

/**
 * PremiumFeatureLock - Wraps premium features with upgrade prompt
 */
function PremiumFeatureLock({ 
  isPremium, 
  feature, 
  children, 
  fullPage = false 
}) {
  const navigate = useNavigate();
  
  if (isPremium) {
    return <>{children}</>;
  }
  
  if (fullPage) {
    return (
      <Box padding="800">
        <BlockStack gap="400" align="center">
          <Icon source={LockIcon} tone="subdued" />
          <Text variant="headingMd" alignment="center">
            {feature} is a Premium Feature
          </Text>
          <Text tone="subdued" alignment="center">
            Upgrade to Premium to unlock this feature and more.
          </Text>
          <Button variant="primary" onClick={() => navigate('/app/billing')}>
            Upgrade to Premium
          </Button>
        </BlockStack>
      </Box>
    );
  }
  
  return (
    <BlockStack gap="300">
      <Banner
        title={`${feature} - Premium Feature`}
        tone="warning"
        action={{
          content: 'Upgrade',
          onAction: () => navigate('/app/billing'),
        }}
      >
        <Text tone="subdued">
          Upgrade to Premium to unlock this feature.
        </Text>
      </Banner>
      
      <Box 
        opacity="0.5" 
        style={{ pointerEvents: 'none', position: 'relative' }}
      >
        {children}
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.3)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Icon source={LockIcon} tone="subdued" />
        </div>
      </Box>
    </BlockStack>
  );
}

export default PremiumFeatureLock;
